import React from 'react';
import LocaleTabs from './LocaleTabs';

interface LocaleFieldWrapperProps {
  children: React.ReactNode;
  enabled?: boolean;
}

const LocaleFieldWrapper: React.FC<LocaleFieldWrapperProps> = ({ 
  children, 
}) => {
  return (
    <div>
      <LocaleTabs/>
      <div>
        {children}
      </div>
    </div>
  );
};

export default LocaleFieldWrapper;